<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div>{{ titleKey | translate }}</div>
    <span class="ui-icon-close c-p" (click)="onCancel()"></span>
  </div>
  <div class="body">
    <div class="input-container flex-col">
      <label class="input-label">{{ 'VEHICLE_GROUPS.NAME_DIALOG.NAME_LABEL' | translate }}</label>
      <input
        class="ui-input ui-input-40 w-100"
        [formControl]="nameControl"
        [placeholder]="'VEHICLE_GROUPS.NAME_DIALOG.NAME_PLACEHOLDER' | translate"
        uiAutofocus
      />
      @if (nameControl.hasError('required') && nameControl.touched) {
        <span class="input-error">{{ 'VEHICLE_GROUPS.NAME_DIALOG.ERROR_REQUIRED' | translate }}</span>
      }
      @if (nameControl.hasError('duplicate')) {
        <span class="input-error">{{ 'VEHICLE_GROUPS.NAME_DIALOG.ERROR_DUPLICATE' | translate: { name: duplicateName } }}</span>
      }
    </div>
  </div>
  <div class="footer flex-row end-center">
    <ui-button type="default" [text]="'COMMON.CANCEL' | translate" (clickAction)="onCancel()"></ui-button>
    <ui-button
      type="primary"
      [text]="submitKey | translate"
      [disabled]="nameControl.invalid || !nameControl.value?.trim()"
      (clickAction)="onContinue()"
    ></ui-button>
  </div>
</div>
